/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetRiskBlockRequest,
  GetRiskBlockSecurity,
} from "../models/operations/getriskblock.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRiskGetBlockQuery,
  prefetchRiskGetBlock,
  queryKeyRiskGetBlock,
  RiskGetBlockQueryData,
} from "./riskGetBlock.core.js";
export {
  buildRiskGetBlockQuery,
  prefetchRiskGetBlock,
  queryKeyRiskGetBlock,
  type RiskGetBlockQueryData,
};

export type RiskGetBlockQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getRiskBlock risk
 *
 * @remarks
 * Get a tool call block by its risk result ID for the durable block page.
 */
export function useRiskGetBlock(
  request: GetRiskBlockRequest,
  security?: GetRiskBlockSecurity | undefined,
  options?: QueryHookOptions<RiskGetBlockQueryData, RiskGetBlockQueryError>,
): UseQueryResult<RiskGetBlockQueryData, RiskGetBlockQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildRiskGetBlockQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getRiskBlock risk
 *
 * @remarks
 * Get a tool call block by its risk result ID for the durable block page.
 */
export function useRiskGetBlockSuspense(
  request: GetRiskBlockRequest,
  security?: GetRiskBlockSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    RiskGetBlockQueryData,
    RiskGetBlockQueryError
  >,
): UseSuspenseQueryResult<RiskGetBlockQueryData, RiskGetBlockQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRiskGetBlockQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRiskGetBlockData(
  client: QueryClient,
  queryKeyBase: [parameters: { id: string; gramSession?: string | undefined }],
  data: RiskGetBlockQueryData,
): RiskGetBlockQueryData | undefined {
  const key = queryKeyRiskGetBlock(...queryKeyBase);

  return client.setQueryData<RiskGetBlockQueryData>(key, data);
}

export function invalidateRiskGetBlock(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { id: string; gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "blocks", "get", ...queryKeyBase],
  });
}

export function invalidateAllRiskGetBlock(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "blocks", "get"],
  });
}
